// Reverse view: crash concentrations and whether a deficiency run sits under
// them — the SR-2 study's most actionable table (clusters with NO deficiency
// are the analyses' blind spots).
import React from 'react';

const fmtMp = (v) => (v === null || v === undefined ? '—' : v.toFixed(3));

export default function CrashClustersTable({ clusters, crashes, runs, analysis, onFocus }) {
  if (!clusters?.length) return <div className="safety-muted">No crash clusters (2+ crashes within 0.3 mi).</div>;
  const crashById = new Map((crashes || []).map((c) => [c.id, c]));

  const onRun = (cl) =>
    (runs || []).some((r) => (r.corridor || '') === (cl.corridor || '')
      && cl.mpStart <= r.mpEnd + 0.1 && cl.mpEnd >= r.mpStart - 0.1);
  const multi = new Set((clusters || []).map((c) => c.corridor || '')).size > 1;

  return (
    <div className="safety-table-scroll">
      <table className="safety-table safety-table-clickable">
        <thead>
          <tr>
            {multi && <th>Corridor</th>}<th>Milepost</th><th>Crashes</th><th>{analysis} deficiency</th>
            <th>Leading type</th><th>Towns</th>
          </tr>
        </thead>
        <tbody>
          {clusters.map((cl, i) => {
            const members = cl.crashIds.map((id) => crashById.get(id)).filter(Boolean);
            const manners = {};
            const towns = new Set();
            members.forEach((m) => {
              manners[m.manner] = (manners[m.manner] || 0) + 1;
              if (m.city) towns.add(m.city);
            });
            const leading = Object.entries(manners).sort((a, b) => b[1] - a[1])[0]?.[0] || '—';
            const hit = onRun(cl);
            return (
              <tr
                key={i}
                className={hit ? '' : 'safety-row-miss'}
                onClick={() => onFocus && onFocus({
                  lat: cl.lat, lng: cl.lng, zoom: 15,
                  key: `cluster-${i}-${Date.now()}`,
                })}
                title="Show this cluster on the map"
              >
                {multi && <td>{cl.road || cl.corridor}</td>}
                <td>{fmtMp(cl.mpStart)}{cl.mpEnd > cl.mpStart ? `–${fmtMp(cl.mpEnd)}` : ''}</td>
                <td>{cl.count}</td>
                <td>
                  <span className={hit ? 'safety-chip safety-chip-bad' : 'safety-chip safety-chip-neutral'}>
                    {hit ? 'yes' : 'none'}
                  </span>
                </td>
                <td>{leading}</td>
                <td>{[...towns].join(', ') || '—'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
